/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLaptopPhoneSlash: {
  name: 'laptop-phone-slash';
  data: string;
} = {
  name: 'laptop-phone-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414ZM8 3a1 1 0 0 0 0 2h11v3a1 1 0 1 0 2 0V5a2 2 0 0 0-2-2H8ZM3 8v7a2 2 0 0 0 2 2h7a1 1 0 1 0 0-2H5V8a1 1 0 0 0-2 0Zm0 11a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H3Zm13-9a1 1 0 1 0 0 2h4v5a1 1 0 1 0 2 0v-5a2 2 0 0 0-2-2h-4Z" fill="currentColor"/></svg>`,
};
